import { inject, Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { IqEventBusBrokerService } from "@dat/iq-event-bus";
import { IqMcModalComponent } from "../../iq-mc-modal-mci/iq-mc-modal-mci.component";

@Injectable({
    providedIn: 'root',
})
export class IqMcModalEventService {
    private _bus: IqEventBusBrokerService = inject(IqEventBusBrokerService);
    constructor(private _dialog: MatDialog) {
        this._bus.registerMap({
            openMcModalMci: {
                callback: (payload: { id: string }) => {
                    this.openMciModal(payload);
                },
            }

        })
    }

    openMciModal(data: any) {
        const diaglogRef: MatDialogRef<IqMcModalComponent> = this._dialog.open(IqMcModalComponent, {
            width: '682px',
            height: '724px',
            data: {
                ...data,
                close: () => {
                    diaglogRef.close();
                },
            },
        });
    }
}